import React, { useContext } from "react";
import NotificationSlider from "./components/NotificationSlider";
import ProfileComponent from "./components/Profile";
import { HiMenu } from "react-icons/hi";
import { DrawerContext } from "../sidebar/Layout";
import { Box } from "@mui/material";

const Header = (props: any) => {
  const { setIsOpenDrawer, isOpenDrawer } = useContext(DrawerContext);

  const toggleDrawer = () => {
    setIsOpenDrawer(!isOpenDrawer);
  };

  return (
    <>
      <header>
        <Box
          className="d-flex justify-content-between align-items-center py-1 px-3 w-100"
          style={{
            backgroundColor: "var(--headerColor)",
            zIndex: 1000,
            flexWrap: "wrap",
          }}
        >
          <Box className="d-flex align-items-center">
            <HiMenu size={28} onClick={toggleDrawer} className="d-md-none" />
          </Box>
          <Box
            className="d-none d-md-flex flex-grow-1 justify-content-start"
            style={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              alignItems: "center",
            }}
          >
            <NotificationSlider />
          </Box>
          <Box className="d-flex align-items-center ms-3" style={{ flexShrink: 0 }}>
            <ProfileComponent />
          </Box>
        </Box>
      </header>
      {/* Sadece mobil (assemp) ekranda görüntülenecek NotificationSlider */}
      <Box className="d-md-none px-3 py-2 shadow-bottom" 
      style={{
        backgroundColor: "var(--headerColor)",
      }}>
        <NotificationSlider />
      </Box>
    </>
  );
};

export default Header;
